import React from 'react';
import { AccordionDetails, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { AccountData, OrderData, OrderPageData } from '../../../../../api';
import PersonalDetailsStep from './PersonalDetailsStep';
import { Accordion, AccordionSummary, AccordionSummaryVariant } from '../Accordion';
import { PrefillButton } from '../../externalPrefill/PrefillButton';
import { useAuth } from '../../../../../session/InternalAuthProvider';
import { EditOrderFormValues, EditOrderPanels } from '../../EditOrderDialog';
import { OrderPageIntent } from '../../OrderPageIntent';

type PersonalDetailsPanelProps = {
  orderOrVoucher: Partial<OrderData> & {
    voucher_greeting_message?: string;
    recipient_email?: string;
    delivery_timestamp?: string;
  };
  isExistingOrder: boolean;
  orderPage: OrderPageData;
  isOneOfVoucherIntents?: boolean;
  setOrderCustomDetails: (details: any) => void;
  expanded?: EditOrderPanels;
  handleChange: any;
};
export const PersonalDetailsPanel = ({
  orderOrVoucher,
  isExistingOrder,
  orderPage,
  isOneOfVoucherIntents,
  setOrderCustomDetails,
  expanded,
  handleChange,
}: PersonalDetailsPanelProps) => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const { t } = useTranslation();
  const { values } = useFormikContext<EditOrderFormValues>();
  const previewName = `${values.firstname} ${values.lastname}`;

  return (
    <Accordion
      onChange={handleChange}
      expandedPanelName={expanded}
      panelName={EditOrderPanels.PersonalDetailsPanel}
      allOpenValue={EditOrderPanels.AllOpen}>
      <AccordionSummary
        variant={AccordionSummaryVariant.CAPTION}
        title={t('calendar.edit_order.personal')}
        summaryComponent={
          <Grid container gap={1.5} wrap="wrap">
            <Typography fontWeight={600}>{previewName}</Typography>
            {values.phone && (
              <Typography dir="ltr" color="text.secondary">
                {values.phone}
              </Typography>
            )}
          </Grid>
        }
      />
      <AccordionDetails>
        <PersonalDetailsStep
          orderPage={orderPage}
          orderPageIntent={isOneOfVoucherIntents ? OrderPageIntent.GIFT_CARD : OrderPageIntent.BUY_NOW}
          setOrderCustomDetails={setOrderCustomDetails}
          orderCustomDetails={orderOrVoucher.custom_details}
          holidayCalendar={account.holiday_calendar}
          showReferralSource={isExistingOrder}
        />
        <PrefillButton />
      </AccordionDetails>
    </Accordion>
  );
};
